import { TextAreaAppearance, TextInputAppearance } from './shared';
export var getColor = function getColor(props) {
  var color;

  if (!props.theme) {
    return;
  }

  switch (props.appearance) {
    case TextAreaAppearance.ReadOnly:
    case TextInputAppearance.ReadOnly:
      color = props.theme.interaction.recipe100.default;
      break;

    case TextAreaAppearance.Disabled:
    case TextInputAppearance.Disabled:
      color = props.theme.interaction.recipe500.disabled;
      break;

    default:
      color = props.theme.interaction.recipe500.default;
  }

  return color;
};
export var getLabelIconColor = function getLabelIconColor(props) {
  var color;

  if (!props.theme) {
    return;
  }

  switch (props.appearance) {
    case TextAreaAppearance.ReadOnly:
    case TextInputAppearance.ReadOnly:
      color = props.theme.interaction.recipe100.default;
      break;

    case TextAreaAppearance.Disabled:
    case TextInputAppearance.Disabled:
      color = props.theme.interaction.recipe500.disabled;
      break;

    case TextAreaAppearance.Search:
    case TextInputAppearance.Search:
      color = props.theme.interaction.recipe400.default;
      break;

    default:
      color = props.theme.interaction.recipe500.default;
  }

  return color;
};
export var getStatusColor = function getStatusColor(props) {
  var color;

  if (!props.theme) {
    return;
  }

  switch (props.appearance) {
    case TextAreaAppearance.Error:
    case TextInputAppearance.Error:
      color = props.theme.interaction.recipe360.default;
      break;

    case TextAreaAppearance.Disabled:
    case TextInputAppearance.Disabled:
      color = props.theme.interaction.recipe150.disabled;
      break;

    default:
      color = props.theme.interaction.recipe150.default;
  }

  return color;
};